import { DESKTOP_MEDIA_QUERY, useMediaQuery } from '../hooks/useMediaQuery';
import { DeviceType } from '../api/openapi_gen/deliveryProviderPortal/deliveryProviderPortal/apis';

export function useDeviceType(): DeviceType {
  const isDesktop = useMediaQuery(DESKTOP_MEDIA_QUERY);
  const isMobile = useMediaQuery('(max-width: 471.95px)');

  if (isDesktop) {
    return DeviceType.DESKTOP;
  }

  if (isMobile) {
    return DeviceType.MOBILE;
  }

  return DeviceType.TABLET;
}
